var applicability = {
    applicabilityCriteria: {
        country: "country_other",
        language: "language_other",
        platform: "platform_device_other"
    },
    applicabilityCriteriaArray: [],
    listApplicabilities: {},
    inclusive_suffix: "slmt",
    exclusive_suffix: "exclu",
    urlFile: "app/applicability/data-applicabilities.json"
};

applicability.init = function(callback) {
    applicability.loadApplicabilityCriteria(function() {
        applicability.applicabilityCriteriaArray = [];
        var keys = Object.keys(applicability.applicabilityCriteria);
        keys.forEach(function(key){
            applicability.applicabilityCriteriaArray.push(applicability.applicabilityCriteria[key]);
        });
        applicability.loadDataApplicabilities(callback);
    });
}

applicability.initApplicabilityCriteria = function(callback) {
    applicability.loadApplicabilityCriteria(function() {
        applicability.applicabilityCriteriaArray = [];
        var keys = Object.keys(applicability.applicabilityCriteria);
        keys.forEach(function(key){
            applicability.applicabilityCriteriaArray.push(applicability.applicabilityCriteria[key]);
        });

        if ( callback !== undefined ) {
            callback.apply(this, []);
        }
    });
}

applicability.loadApplicabilityCriteria = function(callback) {
    applicability.applicabilityCriteria.platform = "platform_device_" + device.platform;

    function getCountryUser(callback) {
        getPreference('userCountry',
            function success(countryCode) {
                applicability.applicabilityCriteria.country = "country_" + countryCode.toUpperCase();
                callback.apply(this, []);
            },
            function fail() {
                var langSplit = navigator.language.split("-");

                var countryCode = "other";
                if ( langSplit !== undefined && langSplit.length > 1 ) {
                    countryCode = navigator.language.split("-")[1];
                }

                applicability.applicabilityCriteria.country = "country_" + countryCode.toUpperCase();
                callback.apply(this, []);
            }
        );
    }

    getPreference('langue',
      function succes(value) {
          applicability.applicabilityCriteria.language = "language_" + value;
          getCountryUser(callback);
      },
      function fail() {
          var lang = navigator.language.split("-");

          if ( lang !== undefined && lang.length !== 0 ) {
              langueDevice = lang[0];
          }

          applicability.applicabilityCriteria.language = "language_" + langueDevice;
          getCountryUser(callback);
      }
    );
}

applicability.loadDataApplicabilities = function(callback) {
    $.ajax({
    url: applicability.urlFile
    , global: false
    , dataType: "json"
    , async: true
    , success: function success(dataAjax, textStatusAjax, jqXHRAjax) {
        var data = dataAjax;
        applicability.listApplicabilities = data;
        callback.apply(this, []);
    }
    , error: function fail() {
      console.log("error loading data");
    }
    });
}

applicability.testIfApplicable = function(applicabilityName) {
    if ( psa_params.data.isDoc === undefined ) {
      var listApplicabilities = applicability.listApplicabilities[0][applicabilityName];

      for ( var i = 0; i < applicability.applicabilityCriteriaArray.length; i++ ) {
          var criteria = applicability.applicabilityCriteriaArray[i];

          for ( var j = 0; j < listApplicabilities.length; j++ ) {
              var applicabilityValue = listApplicabilities[j];
              var applicabilityValueSplit = applicabilityValue.split("_");

              if ( applicabilityValueSplit.length > 1 ) {
                  var value = applicabilityValueSplit[0];
                  for ( var index = 1; index < applicabilityValueSplit.length - 1; index++ ) {
                      value += "_" + applicabilityValueSplit[index];
                  }

                  var behavior = applicabilityValueSplit[applicabilityValueSplit.length - 1];

                  if ( value === criteria ) {
                      if ( behavior === applicability.inclusive_suffix ) {
                          return true;
                      }
                      else if ( behavior === applicability.exclusive_suffix ) {
                          return false;
                      }
                  }
              }
          }
      }

      return false;
    }
}

applicability.filter = function($context) {
    var elements = $($context).find("[data-applicability]");

    for ( var i = 0; i < elements.length; i++ ) {
        var $elementTarget = $(elements[i]);
        var dataApplicabilities = $($elementTarget).attr("data-applicability");
        var listApplicabilitiesElement = dataApplicabilities.split(" ");

        for ( var index in listApplicabilitiesElement ) {
            if ( listApplicabilitiesElement.hasOwnProperty(index) ) {
              var isApplicable = applicability.testIfApplicable(listApplicabilitiesElement[index]);

              if ( isApplicable === false ) {
                  $($elementTarget).remove();
                  return;
              }
            }
        }
    }
}
